/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pcr_pertube = /** @type {(inputs: { vol: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aliquot ${i?.vol} µL of master mix per tube, then add template.`)
};

const es_pcr_pertube = /** @type {(inputs: { vol: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Distribuye ${i?.vol} µL de master mix por tubo y luego añade el molde.`)
};

const de_pcr_pertube = /** @type {(inputs: { vol: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aliquotieren Sie ${i?.vol} µL Mastermix pro Röhrchen und geben Sie dann die Template-DNA hinzu.`)
};

const nl_pcr_pertube = /** @type {(inputs: { vol: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verdeel ${i?.vol} µL mastermix per buisje en voeg vervolgens template toe.`)
};

const fr_pcr_pertube = /** @type {(inputs: { vol: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Répartissez ${i?.vol} µL de mix maître par tube, puis ajoutez la matrice.`)
};

const it_pcr_pertube = /** @type {(inputs: { vol: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aliquota ${i?.vol} µL di master mix per provetta, quindi aggiungi il template.`)
};

const pt_br2_pcr_pertube = /** @type {(inputs: { vol: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Distribua ${i?.vol} µL de master mix por tubo e depois adicione o molde.`)
};

const pt_pcr_pertube = /** @type {(inputs: { vol: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alíquote ${i?.vol} µL de master mix por tubo e depois adicione o molde.`)
};

const ja_pcr_pertube = /** @type {(inputs: { vol: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`マスターミックスを1チューブあたり${i?.vol} µL分注し、その後テンプレートを加えてください。`)
};

const zh_pcr_pertube = /** @type {(inputs: { vol: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`每管分装 ${i?.vol} µL 混合液，然后加入模板。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ vol: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pcr_pertube = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pcr_pertube(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pcr_pertube", locale)
	if (locale === "en") return en_pcr_pertube(inputs)
	if (locale === "es") return es_pcr_pertube(inputs)
	if (locale === "de") return de_pcr_pertube(inputs)
	if (locale === "nl") return nl_pcr_pertube(inputs)
	if (locale === "fr") return fr_pcr_pertube(inputs)
	if (locale === "it") return it_pcr_pertube(inputs)
	if (locale === "pt-BR") return pt_br2_pcr_pertube(inputs)
	if (locale === "pt") return pt_pcr_pertube(inputs)
	if (locale === "ja") return ja_pcr_pertube(inputs)
	return zh_pcr_pertube(inputs)
};